import { render, staticRenderFns } from "./AppointmentReportDetailsSidebar.vue?vue&type=template&id=b0d084f2"
import script from "./AppointmentReportDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./AppointmentReportDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppointmentReportDetailsSidebar.vue?vue&type=style&index=0&id=b0d084f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports